import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47f677ab&scoped=true&lang=pug"
import script from "./code.js?vue&type=script&lang=js&external"
export * from "./code.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=47f677ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f677ab",
  null
  
)

export default component.exports